import { HealthTeam } from "@/@types/esus/HealthTeam";
import { HealthUnit } from "@/@types/esus/HealthUnit";
import { PaginationFilter } from "@/@types/generics/genericals";
import { Paginated } from "@/@types/generics/paginated";
import { esusApi } from "@/services/api";
import { IndicatorEsfStatusEnum } from "@/utils/enums/IndicatorEsfStatusEnum";

export type DetailedCitizenScoresIndicatorC6Params = Partial<PaginationFilter> & {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	search: string;
	ine?: string;
	isEvaluated?: boolean;
	export?: boolean;
};

export type DetailedCitizenScoresIndicatorC6Data = {
	id: number;
	cpf?: string;
	cns?: string;
	birthdate: string;
	fullName: string;
	healthUnitId: number;
	healthTeamId: number;
	healthUnit?: HealthUnit;
	healthTeam?: HealthTeam;
	area?: string;
	motherName?: string;
	gender?: number;
	street?: string;
	houseNumber?: string;
	neighborhood?: string;
	phone?: string;
	lastAttendanceStatus: IndicatorEsfStatusEnum;
	twoWeightAndHeightMetricsRegistersStatus: IndicatorEsfStatusEnum;
	twoHomeVisitsStatus: IndicatorEsfStatusEnum;
	vaccinationStatus: IndicatorEsfStatusEnum;
	score: number;
};

export async function getDetailedCitizensScoresIndicatorC6({
	uf,
	ibgeCode,
	...params
}: DetailedCitizenScoresIndicatorC6Params) {
	const response = await esusApi.get<Paginated<DetailedCitizenScoresIndicatorC6Data>>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esf/c6/detailed-citizens-scores`,
		params
	);
	return response.data ?? new Paginated<DetailedCitizenScoresIndicatorC6Data>();
}
